import { MsalAuthProvider, LoginType } from "react-aad-msal";

// Msal Configurations

const config = {
  auth: {
    authority: "https://login.microsoftonline.com/fe51472c-6660-4ae5-995a-ac0f14ef2b07",
    clientId: "c7657147-6aaf-4823-a61f-98b01746067e",
    // authority: "https://login.microsoftonline.com/0fcc44cc-5868-4897-981e-7b04f79d61d8",
    // clientId: "b3ecd430-b87f-4893-a91d-acd37a29117a",
    //redirectUri: "https://dgb4fs7wtnrk4.cloudfront.net",
    //!solo para probar local
    // redirectUri: "http://localhost:3000",

    //? prod actual
    // redirectUri: "https://gl-woe.appalsea.com",
    redirectUri: "https://da758i5fj3oji.cloudfront.net",

    // redirectUri: "https://dev.centro.operaciones.alsea.net",
    // redirectUri: "https://dx78ko4g1087t.cloudfront.net",
    validateAuthority: true,
    navigateToLoginRequestUrl: true,
  },

  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

// Authentication Param
const authenticationParameters = {
  scopes: ["openid", "profile", "user.read"],
};

// Options

const options = {
  loginType: LoginType.Redirect,
  tokenRefreshUri: window.location.origin + "/auth.html",
};

// Singleton instance holder
let authProviderInstance = null;

// Function to get or create the singleton instance
export const getAuthProvider = () => {
  if (!authProviderInstance) {
    console.log("Creating new MsalAuthProvider instance ")
    authProviderInstance = new MsalAuthProvider(config, authenticationParameters, options);
  }
  return authProviderInstance;
};

// Function to configure params AND recreate the instance
export const configureAuthParams = (newAuthority, newClientId) => {
  console.log("Reconfiguring AuthProvider with:", newAuthority, newClientId);

  if (newAuthority) {
    config.auth.authority = newAuthority;
  }
  if (newClientId) {
    config.auth.clientId = newClientId;
  }

  // Force recreation of the instance
  // Note: This will replace the singleton, so subsequent calls to getAuthProvider()
  // or usages via the Proxy will use this new instance.
  authProviderInstance = new MsalAuthProvider(config, authenticationParameters, options);

  return authProviderInstance;
};

// Export a default instance for backward compatibility.
// The Proxy ensures that if 'authProviderInstance' is replaced by configureAuthParams,
// consumers of this export will automatically start using the new instance.
export const authProvider = new Proxy({}, {
  get: function(target, prop) {
    if (!authProviderInstance) {
      console.log("Creating new MsalAuthProvider instance ")
      authProviderInstance = new MsalAuthProvider(config, authenticationParameters, options);
    }
    return authProviderInstance[prop];
  },
  // Forward set operations as well just in case
  set: function(target, prop, value) {
    if (!authProviderInstance) {
      console.log("Creating new MsalAuthProvider instance ")
      authProviderInstance = new MsalAuthProvider(config, authenticationParameters, options);
    }
    authProviderInstance[prop] = value;
    return true;
  }
});
